import { connect } from 'react-redux'
import TackBoardForTodayComponent from '../../components/tack_board/tack_board_for_today';
import * as TackNotificationsActions from '../../stores/tack_notifications/actions';

const mapStateToProps = (state) => {
  return {
    tackNotifications: state.default.tackNotifications,
    user: state.default.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadTackNotifications: () => {
      dispatch(TackNotificationsActions.tackNotifications());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TackBoardForTodayComponent);



// WEBPACK FOOTER //
// ./src/containers/tack_board/tack_board_for_today.js